export default {
  SHOW_DIFM_BANNER: 'showDifmBanner',
  IS_LATEST_USER_AGREEMENT_ACCEPTED: 'isLatestUserAgreementAccepted',
};
